// Canal de la aplicación. Fuente única de verdad: no hardcodear "1"/"2"/"3"
// en los servicios/actions, siempre importar CANAL desde aquí.
export const CANAL = "3";

// Versión de la app enviada en cada request. Fuente única de verdad:
// no hardcodear "1.0"/"1.4"/"2.0.0" en los servicios/actions, importar APP_VERSION.
export const APP_VERSION = "2.0.0";

export const SIZE_IMAGE = 10;
export const TYPES_FILES_IMAGE = ["JPEG", "PNG", "JPG", "BMP"];
export const TYPES_FILES_SEGUROS = ["JPEG", "PNG", "JPG", "BMP", "PDF"];
